import React from 'react';
import { DatePicker, Segmented } from "antd/lib";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { FilterType } from "../../../type/events.types";
import { Dayjs } from 'dayjs';
import events from "../../../../../resources/event";

interface IEventCardToolbar {
    visibleMonth: Dayjs;
    filter: FilterType;
    onFilterChange: (val: FilterType) => void;
    onPrev: () => void;
    onNext: () => void;
    onMonthChange: (date: Dayjs) => void;
}


const EventCardToolbar: React.FC<IEventCardToolbar> = (props) => {

    const resource = events;

    const tabOptions = [
        {
            label: 'Passed',
            value: 'passed' as FilterType
        },
        {
            label: 'Today',
            value: 'today' as FilterType
        },
        {
            label: 'Upcoming',
            value: 'upcoming' as FilterType
        }
    ];

    const resultText = props.filter === 'today' ?
        resource.todaySearchResultText :
        props.filter === 'upcoming' ?
            resource.upcomingSearchResultText :
            resource.passedSearchResultText;

    const monthText = React.useMemo(
        () => props.visibleMonth.format('MMMM YYYY'),
        [props.visibleMonth]
    );


    return (
        <div className={'hrms-events__toolbar'}>

            <div className={`result-range ${props.filter}`}>
                {resultText} {monthText}
            </div>

            <div className={'hrms-events__action-bar'}>
                <DatePicker
                    className={'hrms-events__calendar-picker'}
                    value={props.visibleMonth}
                    onChange={props.onMonthChange}
                    format={"MMMM YYYY"}
                    picker={'month'}
                />
                <div className="hrms-events__calendar-navigation">
                    <span
                        className="nav-icon"
                        onClick={props.onPrev}
                    ><LeftOutlined/>
                    </span>
                    <span
                        className="nav-icon"
                        onClick={props.onNext}
                    >
                    <RightOutlined/>
                    </span>
                </div>
                <Segmented
                    options={tabOptions}
                    value={props.filter}
                    onChange={props.onFilterChange}
                    className="hrms-events__toggle-group event-time-filter"
                />
            </div>
        </div>
    )
}
export default EventCardToolbar;
